import React, { useState } from 'react';

import { Box } from '@rbilabs/components-library/build/components/layout';
import { useIntl } from 'react-intl';

import { AddressFormatType, useAddressFormat } from 'hooks/use-address-format';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import { HomeIcon } from '../home-icon';
import { PinIcon } from '../pin-icon';
import { WorkIcon } from '../work-icon';

import {
  AddressContainer,
  AddressTitleWrapper,
  LabelHeader,
  LabelText,
  LabelWrapper,
  LinkButton,
  LoadingIcon,
} from './styled';
import { IDeliveryAddressItemProps } from './types';

const ICONS = {
  home: HomeIcon(),
  work: WorkIcon(),
  default: PinIcon(),
};

export const DeliveryAddressItem: React.FC<IDeliveryAddressItemProps> = ({
  address,
  onEdit,
  onSelect,
  onDelete,
  showEdit = true,
  showDelete = false,
}) => {
  const { formatMessage } = useIntl();
  const addressFormat = useAddressFormat();

  const [isSelected, setIsSelected] = useState(false);

  const enableSavedAddressesImprovements = useFlag(
    LaunchDarklyFlag.ENABLE_SAVED_ADDRESSES_IMPROVEMENTS
  );

  const icon = address.alias
    ? (ICONS[address.alias.toLowerCase() as keyof typeof ICONS] ?? ICONS.default)
    : ICONS.default;

  const addressLine1 =
    addressFormat === AddressFormatType.NumberName
      ? [
          `${address.streetNumber} ${address.route}`,
          address.city,
          `${address.state} ${address.zip}`,
        ].join(', ')
      : [
          `${address.route} ${address.streetNumber}`,
          address.city,
          `${address.state} ${address.zip}`,
        ].join(', ');

  const handleSelect = () => {
    setIsSelected(true);

    onSelect();
  };

  return (
    <>
      <AddressContainer>
        <AddressTitleWrapper onClick={handleSelect} data-testid="recent-address-item">
          <Box justify="space-between" align="center" position="relative" overflow="hidden">
            <LabelWrapper isSelected={isSelected}>{icon}</LabelWrapper>
            <LabelWrapper isSelected={isSelected}>
              <LabelHeader>{address.alias}</LabelHeader>
              <LabelText>{addressLine1}</LabelText>
            </LabelWrapper>
          </Box>
          {isSelected && <LoadingIcon fillColor={Styles.color.black} />}
        </AddressTitleWrapper>

        {showEdit && enableSavedAddressesImprovements && (
          <LinkButton data-testid="saved-address-edit" onClick={onEdit}>
            {formatMessage({ id: 'edit' })}
          </LinkButton>
        )}

        {!enableSavedAddressesImprovements && showDelete && (
          <LinkButton data-testid="recent-address-delete" onClick={onDelete}>
            {formatMessage({ id: 'remove' })}
          </LinkButton>
        )}
      </AddressContainer>
    </>
  );
};
